<template>
  <div class="page" data-name="conversation" style="padding: 50px 0 0 0">
    <!-- Calling VOIP POPUP -->
    <!-- <voipModal v-bind:data="modalConfig" @endCall="endCall()"></voipModal> -->
    <!-- navbar -->
    <div class="navbar" style="border-bottom: 3px solid #fff">
      <div :class="{
        'navbar-inner sliding navbar-master navbar-current voip':
          modalConfig.visible,
        'navbar-inner sliding navbar-master navbar-current':
          !modalConfig.visible,
      }" :style="user.isEmployee ? 'width:100% !important;' : ''">
        <div class="left">
          <a @click="goBack" class="link back" v-if="!user.isEmployee">
            <i class="icon icon-back"></i>
            <!--  <span class="ios-only">Back</span> -->
          </a>
          <a class="link back" @click="back" v-if="user.isEmployee">
            <i class="icon icon-back"></i>
            <!--  <span class="ios-only">Back</span> -->
          </a>
        </div>

        <div class="title" v-if="user.isEmployee">
          <!-- Employee Header -->
          <div class="item-title wrap">
            <a v-on:click="openLink(targetId)" style="color: #0645ad; text-decoration: underline !important">
              <img v-if="selectedUser && selectedUser.client_photo_url" v-bind:src="selectedUser.client_photo_url"
                style="margin-right: 6px" />
              <img v-else src="../../assets/nophoto.png" style="margin-right: 6px" />
              <span>
                {{
                  fullTitleConversationHeader(
                    selectedUser.client_first_name,
                    selectedUser.client_last_name,
                    selectedUser.client_age,
                    selectedUser.client_gender
                  )
                }}
                ({{ selectedUser.status ? `${selectedUser.status},` : "" }}
                {{ selectedUser.membership_level }})
              </span>
            </a>
            <p style="font-size: 12px; padding-left: 16px">
              <span>Last active:
                {{ selectedUser.last_active_time | timeAgo }}</span>
              <!-- <span></span> -->
            </p>
            <!-- <p
              style="font-size: 12px;padding-left:16px;"
            >({{selectedUser.date_credits_str}}, {{selectedUser.payment_count}})</p>-->
            <!-- Call Button -->
            <!-- <f7-button fill class="voip" v-on:click="openModal">
              <img src="../../assets/call.png" />
            </f7-button>-->
            <!-- End Call Button -->
            <!-- <f7-button
              v-if="user.isEmployee"
              href="javascript:;"
              fill
              class="video"
              @click.stop="openVideoChat"
            >
              <img src="../../assets/video.png" style="height: 30px;width: 30px;" />
            </f7-button>-->
          </div>
        </div>

        <!-- End Employee Header -->

        <!-- Client Header -->
        <div class="notitle" v-else>
          <div class="clientHeader">
            <img
              src="https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/18/2a/4b/182a4bc8-1318-eb11-6cc7-02a8c3326952/AppIcon-MM-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-5.png/217x0w.png" />
            <div v-if="personalMatchMakers()" class="contentTitle">
              <span style="font-weight: 800; font-size: 16px">Assistant</span>
              <!-- Call Button -->
              <!-- <f7-button
                class="voip client"
                @click="callToCs(`tel:+85291428628`)"
                href="tel:+85238987500"
              >
                <img src="@/assets/call.png" />
                <span>+852 9142 8628</span>
              </f7-button>-->
              <!-- End Call Button -->
              <p class="assName">{{ personalMatchMakers() }}</p>
              <p class="assName" v-if="personalMatchMakers()" style="color: #e5e5ea">
                Personal Matchmaker
              </p>
            </div>
            <div class="contentTitle" v-else>
              <span style="font-weight: 800; font-size: 16px" @click="sendMessage(true)">Assistant</span>
              <!-- Call Button -->
              <!-- <f7-button
                class="voip client"
                @click="callToCs(`tel:+85291428628`)"
                href="tel:+85238987500"
              >
                <img src="@/assets/call.png" />
                <span>+852 9142 8628</span>
              </f7-button>-->
              <!-- End Call Button -->
              <p class="assName">
                <a href="javascript:void(0)" @click="sendMessage(true)">Do you want a personal matchmaker?</a>
              </p>
              <p v-if="userInfo.data.booking" class="small">
                Consultation Appointment:
                <a href="javascript:;" class="text-primary" @click="viewConsultation">{{ userInfo.data.booking.date_format
                }}</a>
              </p>
              <p v-else class="small">
                <a href="javascript:;" class="text-primary" @click="bookConsultation">Consultation Appointment</a>
              </p>
            </div>
          </div>
          <!-- End Client Header -->
        </div>
      </div>
      <div v-if="user.isEmployee &&
        targetClient &&
        targetClient.membership_level_id >= 2
        " style="right: 125px; position: fixed; bottom: 11px; cursor: pointer" @click.stop="openShortcutPop">
        <small> <i class="fa fa-hashtag"></i> Shortcut </small>
      </div>

      <div v-if="user.isEmployee" class="refreshSection" title="Refresh conversation section!"
        @click.stop="getMessage(targetId, false)" style="width: 120px; right: 0px; bottom: 42px">
        <small>
          <i class="fa fa-retweet refresh" aria-hidden="true"></i> Refresh
        </small>
      </div>
    </div>

    <!-- Page content -->
    <div class="page-content messages-content" style="padding-bottom: 0px !important">
      <f7-page>
        <f7-messages ref="messages" class="conversation" @click="show = false">
          <!-- Employee Messages(Conversation) -->
          <f7-message class="employee" v-if="user.isEmployee" v-for="(message, index) in messageList.slice().reverse()"
            :key="index" :type="message.to_client_id == targetId ? 'sent' : 'received'"
            :first="isFirstMessage(message, index)" :last="isLastMessage(message, index)"
            :tail="isTailMessage(message, index)" :name="getName(message)">
            <div slot="text" v-if="message.msg" v-html="modifiedMsg(message.msg, message.extras)" :class="{
              repliedMsg: message.msg.toString().indexOf('\n[Reply]') > -1,
            }" :style="chatLineColor(message.extras)"></div>

            <div class="message-image" v-if="message.photo_url">
              <img :src="message.photo_url" />
            </div>
            <div class="message-text-footer">
              {{ message.sent_time | timestamp }}
            </div>
            <div class="reply replyDiv" id="reply" style="cursor: pointer" @click="showContext($event)"
              v-if="!message.photo_url">
              <span class="arrow"></span>
              <ul>
                <li @click="reply($event, message)">Reply</li>
              </ul>
            </div>
            <div class="message-footer" v-if="(message.from_employee_id && message.is_read == 1) ||
              (message.from_employee_id && message.is_replied == 1)
              ">
              <span class="fa-stack fa-lg text-success">
                <i class="fa fa-check fa-stack-1x" style="margin-left: 4px"></i>
                <i class="fa fa-check fa-inverse fa-stack-1x" style="margin-left: -3px"></i>
                <i class="fa fa-check fa-stack-1x" style="margin-left: -4px"></i>
              </span>
            </div>
          </f7-message>
          <!-- End Employee Messages(Converastion) -->

          <!-- Client Side-->
          <f7-message v-if="!user.isEmployee" v-for="(message, index) in messageList.slice().reverse()" :key="index"
            :type="message.from_client_id == null ? 'received' : 'sent'" :first="isFirstMessage(message, index)"
            :last="isLastMessage(message, index)" :tail="isTailMessage(message, index)">
            <div slot="text" v-if="message.msg" v-bind:id="message.client_msg_id"
              v-html="modifiedMsg(message.msg, message.extras)" :class="{
                repliedMsg: message.msg.toString().indexOf('\n[Reply]') > -1,
              }" :style="chatLineColor(message.extras)"></div>
            <div class="message-image" v-if="message.photo_url">
              <img :src="message.photo_url" />
            </div>
            <div class="message-text-footer">
              {{ message.sent_time | timestamp }}
            </div>
            <!-- <div class="reply replyDiv" id="reply" style="cursor:pointer" @click="showContext($event)" v-if="!message.photo_url">
            <span class="arrow"></span>
              <ul>
                <li @click="reply($event,message)">Reply</li>
              </ul>
            </div>-->
          </f7-message>
          <!-- End Client Messages(Converastion) -->
          <f7-message v-if="typingMessage && user.isEmployee" type="received" :typing="true" :first="true" :last="true"
            :tail="true" :header="`${selectedUser ? selectedUser.client_first_name : ''
              } is typing`" :avatar="selectedUser
      ? selectedUser.client_photo_url
      : '../assets/nophoto.png'
    "></f7-message>

          <div v-if="imgPreview.length > 0"
            class="message message-sent message-first message-last message-tail message-appear-from-bottom">
            <div class="message-content">
              <!-- <div class="message-header">0</div> -->
              <div class="message-bubble">
                <div class="message-image">
                  <div class="Imgcontent">
                    <a href="JavaScript:Void(0);">
                      <div class="content-overlay" v-bind:style="{ width: fileUploadPercent + '%' }"></div>
                      <img class="content-image" :src="imgPreview[0]" />
                      <div class="Imgcontent-details fadeIn-bottom">
                        <h3 class="content-title">
                          {{ fileUploadPercent + "%" }}
                        </h3>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="message-text">
                  <div class>{{ message }}</div>
                </div>
              </div>
            </div>
          </div>
          <f7-message v-if="typingMessage && !user.isEmployee" type="received" :typing="true" :first="true" :last="true"
            :tail="true" :header="`Assistant is typing`"></f7-message>
        </f7-messages>
        <div v-if="show" class="emojiDiv" v-closable="{ exclude: ['emjButton'], handler: 'onCloseEmoji' }">
          <span style="cursor: pointer; margin: 5px" v-for="emo in emoji" :key="emo" v-html="emo" @click="addEmo"></span>
        </div>
        <!-- && targetClient.membership_level_id >= 1 -->
        <div v-if="targetClient" :class="{
          'toolbar messagebar messagebar-attachments-visible':
            attachmentsVisible,
          'toolbar messagebar': !attachmentsVisible,
        }" style="position: sticky">
          <input id="uploadBtn" ref="file" type="file" class="upload" @change="onFileChanged"
            accept="image/x-png, image/gif, image/jpeg" style="display: none" />
          <div class="toolbar-inner">
            <a class="link icon-only" style="color: #d5b26f" @click="
              $refs.file.value = '';
            $refs.file.click();
            ">
              <img src="../../assets/camera.png" style="border: none !important" />
            </a>
            <div class="messagebar-area">
              <div class="messagebar-attachments" v-if="!replyStatus">
                <div class="messagebar-attachment" v-for="(image, index) in attachments">
                  <img :key="index" :src="image" />
                  <span class="messagebar-attachment-delete" @click="deleteAttachment(image)"></span>
                </div>
              </div>
              <div class="messagebar-attachments replyAttachment" v-if="replyStatus">
                <div class="messagebar-attachment" v-for="(msg, index) in messageToReply">
                  <h6 :key="index">{{ msg }}</h6>
                  <span class="messagebar-attachment-delete" @click="deleteReplyAttachment()"></span>
                </div>
              </div>
              <textarea :placeholder="placeholder" v-model="message" ref="msgField" @input="typing"
                @paste="onPaste($event)" v-if="!disableSend" @keydown.enter.exact.prevent="sendMessage(false)"
                class="resizable"></textarea>
              <textarea v-else :placeholder="placeholder" v-model="message" ref="msgField" @input="typing"
                @paste="onPaste" class="resizable"></textarea>
              <span class="emojiSpan" ref="emjButton" style @click="toggleShow">&#128512;</span>
            </div>

            <a class="link icon-only" @click="sendMessage(false)" v-if="isvalidMessage()">
              <i class="sendicon" style="color: rgb(213, 178, 111)"></i>
            </a>
          </div>
        </div>
      </f7-page>
    </div>
    <shortcutPop ref="shortcutPop" @sendTplText="sendTplMessage" />
    <scheduleConsultation ref="scheduleConsultation" />
  </div>
</template>
<style scoped src="../../assets/css/conversation.css"></style>
<script>
import Emojis from "../../assets/js/emoji.js";
// import voipModal from "./voip";
// import io from "socket.io-client";
// import Vue from "vue";
// import moment from "moment";
import {
  Url,
  PhoneCodes,
  CallMethods,
  CallPurpose,
  StoreIds,
  DefaultValue,
} from "../../core/const";
import { regEx } from "../../utils/regex";
import { mixin, voipMixin, tencentIM } from "../../utils/mixin";
import shortcutPop from "./components/shortcutPop";
import scheduleConsultation from "./components/scheduleConsultation";
import TIM from "tim-js-sdk";
import TIMUploadPlugin from "tim-upload-plugin";
export default {
  name: "conversation",
  mixins: [mixin, voipMixin, tencentIM],
  components: {
    // voipModal,
    shortcutPop,
    scheduleConsultation,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      mm_user_id: null,
      message: "",
      messages: [],
      messageList: [],
      messageList2: [],
      search: "",
      selectedUser: {},
      observer: null,
      origin: window.location.origin,
      isRecieved: 0,
      typingMessage: false,
      page: 1,
      employee_id: 1,
      regEx: /(<a href(.*?)<\/a>)/,
      loadConversation: true,
      mm: localStorage.getItem("mm") || null,
      userInfo: JSON.parse(localStorage.getItem("userInfoData")),
      popupOpened: false,
      attachments: [],
      imgPreview: [],
      sheetVisible: false,
      selectedFile: null,
      initialLoad: true,
      disableSend: false,
      targetId: null,
      fileUploadPercent: 0,
      city_url: "",
      modalVisible: false,
      replyStatus: false,
      activeCityID: "",
      activeCity: null,
      messageToReply: [],
      replyExtras: [],
      show: false,
      emoji: Emojis,
      targetClient: null,
      imMode: "tim",
      socket: null,
      tim: null,
      currentTIMConversationID: null,
      chatType: "c2c",
    };
  },
  methods: {
    decodeStr(encodedStr){
      const safeStr = encodedStr.replace(/%A0/g, '%C2%A0');
      try{
        return decodeURIComponent(safeStr);
      }catch(err){
        return decodeURI(safeStr);
      }

    },
    destroyTIMGroup() {
      let self = this;
      let formData = new FormData();
      //   formData.append("image", app.selectedFile);
      formData.append("client_id", self.targetId);
      this.$http
        .post(`/api/v2/employee/destroyTIMGroup`, formData)
        .then(function (res) {
          self.chatType = "c2c";
          console.log(res, "destroyTIMGroup");
        })
        .catch(function (e) {
          console.log("FAILURE!!", e);
        });
    },
    onTIMMessageReceived(event) {
      let self = this;

      if (!event.data) {
        return false;
      }
      console.log("onMessageReceived chat info");
      self.setCurrentTIMConversationID();
      for (var msg of event.data) {
        // console.log("sss", msg.conversationID, self.currentTIMConversationID);
        // if (msg.conversationID == self.currentTIMConversationID) {
        if (msg.conversationID.indexOf(self.targetId) > -1) {
          let from = _.get(msg, "from");
          let isFromClient = from.indexOf("c_") > -1 ? true : false;
          if (!isFromClient) {
            continue;
          }

          if (_.get(msg, "type") == "TIMTextElem") {
            self.messageList.unshift({
              isMessageSending: false,
              msg: self.decodeStr(_.get(msg, "payload.text", "")),
              to_client_id: isFromClient ? 0 : self.targetId,
              from_client_id: isFromClient ? self.targetId : 0,
              // from_employee: {
              //   first_name: app.userInfo.data.first_name,
              //   last_name: app.userInfo.data.last_name,
              // },
              photo_url: "",
              sent_time: _.get(msg, "time"),
            });
          }

          //   if (msg.conversationID.indexOf("GROUPM2CG_") > -1) {
          //     self.destroyTIMGroup();
          //   }
          // self.setTIMMessageRead();
        }
      }
    },
    onTIMSdkReady() {
      let self = this;
      console.log("ready...");
      //   self.getTIMConversationList();
      //   self.loopTIMConversationList(2000);
      //   if (self.targetClientId > 0 || self.targetClientId == self.employeeTag) {
      //     self.getTIMMessageList();
      //   }
    },
    onSdkNotReady() { },

    setCurrentTIMConversationID() {
      let self = this;
      //   if (self.clientId > 0) {
      //     self.currentTIMConversationID = `C2Cc_${self.targetClientId}`;
      //   } else if (self.targetClientId == self.employeeTag) {
      self.currentTIMConversationID = `GROUPM2CG_${self.targetId}`;
      //   }
    },
    setTIMMessageRead() {
      let self = this;

      self.setCurrentTIMConversationID();
      self.tim
        .setMessageRead({
          conversationID: self.currentTIMConversationID,
        })
        .then(function (imResponse) {
          // 已读上报成功，指定 ID 的会话的 unreadCount 属性值被置为0
          console.log(
            "setTIMMessageRead",
            self.setCurrentTIMConversationID(),
            imResponse
          );
        })
        .catch(function (imError) {
          // 已读上报失败
          console.warn("setMessageRead error:", imError);
        });
    },
    getM2CGroupID(clientId) {
      return `M2CG_${clientId}`;
    },
    sentTIMTextMsg() {
      let self = this;
      //   if (!toUserID) {
      //     toUserID = self.getToUserID();
      //   }
      // clientId: app.targetId,
      //             message: escape(app.message),
      //             cityId: app.activeCityID,
      //   console.log("toUserID=", toUserID);
      // 发送文本消息，Web 端与小程序端相同
      // 1. 创建消息实例，接口返回的实例可以上屏
      let message = self.tim.createTextMessage({
        to: self.getM2CGroupID(self.targetId),
        conversationType: TIM.TYPES.CONV_GROUP, //TIM.TYPES.CONV_C2C,//TIM.TYPES.CONV_GROUP
        // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
        // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
        // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
        payload: {
          text: self.message,
        },
        // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
        // cloudCustomData: 'your cloud custom data'
      });
      //   console.log("message", message);
      // 2. 发送消息
      let promise = self.tim.sendMessage(message);
      promise
        .then(function (imResponse) {
          // 发送成功
          console.log("send msg", imResponse);
          //   if (_.get(imResponse, "data.message")) {
          //     self.TIMMessageList = [
          //       ...self.TIMMessageList,
          //       ...[_.get(imResponse, "data.message")],
          //     ];
          //   }

          //   self.message = "";
          //   self.isSending = false;
          for (var i in self.messageList) {
            if (self.messageList[i]["isMessageSending"]) {
              self.messageList[i]["isMessageSending"] = false;
            }
          }

          //   self.scrollToBottom();
        })
        .catch(function (imError) {
          // 发送失败
          console.warn("sendMessage error:", imError);
        });
    },
    sentTIMImageMsg() {
      let self = this;

      let message = self.tim.createImageMessage({
        to: self.getM2CGroupID(self.targetId),
        conversationType: TIM.TYPES.CONV_GROUP,
        // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
        // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
        // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
        payload: {
          //   file: document.getElementById("uploadBtn"),
          file: self.selectedFile,
        },
        // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
        // cloudCustomData: 'your cloud custom data'
        onProgress: function (event) {
          self.fileUploadPercent = Math.round(event * 100);
          console.log("file uploading:", event);
        },
      });

      // 2. 发送消息
      let promise = self.tim.sendMessage(message);
      promise
        .then(function (imResponse) {
          // 发送成功
          console.log("发送成功", imResponse);
          //from
          let msgData = {
            to_client_id: self.targetId,

            isMessageSending: false,
            msg: "",
            photo_url: _.get(
              imResponse,
              "data.message.payload.imageInfoArray.0.url"
            ),
            sent_time: _.get(imResponse, "data.message.time"),
          };
          self.messageList.unshift(msgData);

          localStorage.setItem("msg", "received");
          self.attachments = [];
          self.imgPreview = [];
          self.message = "";
          self.fileUploadPercent = 0;
        })
        .catch(function (imError) {
          // 发送失败
          console.warn("sendMessage error:", imError);
        });
    },
    chatLineColor(extras) {
      let e_color = _.get(extras, "color", "");
      if (e_color) {
        return {
          color: e_color,
        };
      }
      return null;
    },
    viewConsultation() {
      this.$refs.scheduleConsultation.open(2);
    },
    bookConsultation() {
      this.$refs.scheduleConsultation.open(1);
    },
    openShortcutPop() {
      // console.log("openShortcutPop");
      this.$refs.shortcutPop.open(this.selectedUser);
    },
    openVideoChat() {
      const app = this;
      let token = localStorage.getItem("token");
      let url = `https://service2.lovestruck.com/video/index.html?type=employee&roomId=${app.targetId}&token=${token}`;
      let features =
        "height=600, width=750, top=100, left=100, toolbar=no, menubar=no,scrollbars=no,resizable=no, location=no, status=no";
      // console.log("video url=", url);
      window.open(url, "videoChat", features);
      // console.log("opened");
      return false;
    },
    //Get Messages
    async getMessage(id, isNotification) {
      // console.log('|.....getMessage....|')
      const app = this;
      let targetId = id;
      app.targetId = targetId;

      //   if (!app.selectedUser.tencent_im_groupID) {
      //     await app.$http
      //       .get(`/api/v2/${app.type}/applyCreateTIMGroup?client_id=${id}`)
      //       .then((rs) => {
      //         console.log("applyCreateTIMGroup", rs);
      //         if (_.get(rs, "data.success", false)) {
      //           app.selectedUser.tencent_im_groupID = _.get(
      //             rs,
      //             "data.group_info.GroupId",
      //             ""
      //           );
      //         }
      //       });
      //   }

      console.log("get message...");
      this.cID = targetId;
      if (!isNotification) {
        /*    app.messageList = [];*/
        app.$f7.dialog.preloader();
      }
      let conersationUrl = "";
      if (app.user.isEmployee) {
        conersationUrl = `/api/v2/${app.type}/conversation?clientId=${targetId}`;
      } else {
        conersationUrl = `/api/v2/${app.type}/conversation`;
      }
      await this.$http
        .get(conersationUrl)
        .then((response) => {
          app.targetClient = _.get(response, "data.target");
          if (self.imMode == "tim") {
            self.setTIMMessageRead();
          }
          //   console.log("app.targetClient=", app.targetClient);
          if (response.data.messages.length > 0) {
            if (response.data.messages.length < 200) {
              app.loadConversation = false;
            }
            let filteredList = app.removeDuplicates(response.data.messages);
            app.messageList = [];
            app.messageList = app.removeDuplicates([
              ...app.messageList,
              ...filteredList,
            ]);
          } else {
            app.loadConversation = false;
          }

          if (!app.user.isEmployee) {
            app.getSomeAutoChat();
          }
          app.$f7.dialog.close();
          // app.scrollDown();

          setTimeout(function () {
            app.scrollDown();
          }, 1800);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getSomeAutoChat() {
      const app = this;

      this.$http.get("/api/v2/client/autoChat").then((rs) => {
        let autoChat = _.get(rs, "data.chat");
        if (_.get(autoChat, "type") == 1 && _.get(autoChat, "msg")) {
          app.sendTplMessage({ tpl_text: _.get(autoChat, "msg", "") });
        }
      });
    },
    sendTplMessage(data) {
      const app = this;
      let tplMessage = _.get(data, "tpl_text");
      if (!tplMessage) {
        app.$refs.shortcutPop.close();
        return false;
      }
      // console.log("tplMessage=", tplMessage);
      // return false;
      if (app.messageToReply.length > 0) {
        let quotes = app.messageToReply[0];
        app.message = quotes + "\n[Reply]" + tplMessage;
      }
      if (app.user.isEmployee) {
        // this.socket.emit("message", {
        //   clientId: app.targetId,
        //   message: tplMessage,
        //   cityId: app.activeCityID,
        //   autoInsert: false,
        // });

        app.messageList.unshift({
          isMessageSending: true,
          msg: tplMessage,
          to_client_id: app.targetId,
          from_client_id: null,
          from_employee: {
            first_name: app.userInfo.data.first_name,
            last_name: app.userInfo.data.last_name,
          },
          sent_time: new Date().toString(),
        });
        app.saveToServer("employee");
      } else {
        // this.socket.emit("message", {
        //   employeeId: app.targetId,
        //   message: escape(app.message),
        //   cityId: app.activeCityID,
        //   autoInsert: false,
        // });
        app.typingMessage = false;
        app.messageList.unshift({
          msg: app.message,
          from_client_id: app.targetId,
          from_employee_id: null,
          sent_time: new Date().toString(),
        });
        app.saveToServer("client");
      }
      app.message = "";
      app.messageToReply = [];
      app.replyExtras = [];
      app.$refs.shortcutPop.close();
    },
    //Send Messages
    sendMessage(reuestMactcher) {
      // console.log("........sendMessage........", reuestMactcher);
      const app = this;
      const _this = this;
      var response = {};
      if (reuestMactcher) {
        app.message = "I want a personal matchmaker, how can I get one?";
      }

      if (
        app.message.length > 0 ||
        app.attachments.length > 0 ||
        app.messageToReply.length > 0
      ) {
        if (app.user.isEmployee) {
          if (app.attachments.length > 0) {
            app.sendImage("client");
          } else {
            if (this.isvalidMessage()) {
              if (app.messageToReply.length > 0) {
                let quotes = app.messageToReply[0];
                app.message = quotes + "\n[Reply]" + app.message;
              }
              // if (app.imMode == "websocket") {
              //   this.socket.emit("message", {
              //     clientId: app.targetId,
              //     message: escape(app.message),
              //     cityId: app.activeCityID,
              //     autoInsert: false,
              //   });
              // }
              //   if (app.imMode == "tim") {
              //     app.sentTIMTextMsg();
              //   }

              app.messageList.unshift({
                isMessageSending: true,
                msg: app.message,
                to_client_id: app.targetId,
                from_client_id: null,
                from_employee: {
                  first_name: app.userInfo.data.first_name,
                  last_name: app.userInfo.data.last_name,
                },
                sent_time: new Date().toString(),
                extras: app.replyExtras
              });

              //   if (app.imMode == "websocket") {
              app.saveToServer("client");
              //   }

              app.message = "";
              app.messageToReply = [];
              app.replyExtras = [];
            }
          }
        } else {
          if (app.attachments.length > 0) {
            app.sendImage("employee");
          }
          if (app.messageToReply.length > 0) {
            let quotes = app.messageToReply[0];
            app.message = quotes + "\n[Reply]" + app.message;
          }
          if (this.isvalidMessage() && app.attachments.length == 0) {
            // if (app.imMode == "websocket") {
            //   this.socket.emit("message", {
            //     employeeId: app.targetId,
            //     message: escape(app.message),
            //     cityId: app.activeCityID,
            //     autoInsert: false,
            //   });
            // }

            app.typingMessage = false;
            app.messageList.unshift({
              msg: app.message,
              from_client_id: app.targetId,
              from_employee_id: null,
              sent_time: new Date().toString(),
              extras: app.replyExtras
            });
            // if (app.imMode == "websocket") {
            app.saveToServer("employee");
            // }

            app.message = "";
          }
        }
      }
      var el = document.getElementsByTagName("textarea")[0];
      $(el).height(20);
      app.attachments = [];
      app.messageToReply = [];
      app.replyExtras = [];
    },
    onEnter: function (e) {
      e.stopPropagation();
      e.preventDefault();
      e.returnValue = false;
    },
    isFirstMessage(message, index) {
      const self = this;
      const previousMessage = self.messageList[index - 1];
      if (
        !previousMessage ||
        previousMessage.replied !== message.replied ||
        previousMessage.first_name !== message.first_name
      )
        return true;
      return false;
    },
    isLastMessage(message, index) {
      const self = this;
      const nextMessage = self.messageList[index + 1];
      if (
        !nextMessage ||
        nextMessage.replied !== message.replied ||
        nextMessage.first_name !== message.first_name
      )
        return true;
      return false;
    },
    isTailMessage(message, index) {
      const self = this;
      const nextMessage = self.messageList[index + 1];
      if (message.isTitle) return false;
      if (
        !nextMessage ||
        nextMessage.replied !== message.replied ||
        nextMessage.first_name !== message.first_name
      )
        return true;
      return false;
    },
    getName(message) {
      if (message && message["isMessageSending"]) {
        return "sending...";
      }
      if (message && !message["isMessageSending"]) {
        return `${message.from_employee_id == 0
            ? "ONLINE SYSTEM"
            : message.from_employee &&
              message.from_employee.first_name &&
              message.from_employee.last_name
              ? message.from_employee.first_name +
              " " +
              message.from_employee.last_name
              : message.from_employee && message.from_employee.first_name
                ? message.from_employee.first_name
                : ""
          }`;
      }
    },
    saveToServer(to) {
      const app = this;

      let formData = new FormData();
      //   formData.append("image", app.selectedFile);
      formData.append("message", app.message);

      //   if (app.imMode == "tim") {
      //     formData.append("use_tim", 1);
      //   }
      formData.append("use_socket", 1);
      formData.append("use_tim", 1);
      if (to == "client") {
        formData.append("clientId", app.targetId);
      }
      if (to == "employee") {
        formData.append("clientId", app.targetId);
      }
      if (app.replyExtras && app.replyExtras.t) {
        formData.append("link_type", app.replyExtras.t);
      }
      if (app.replyExtras && app.replyExtras.id) {
        formData.append("link_target_id", app.replyExtras.id);
      }
      this.$http
        .post(`/api/v2/${app.type}/sendMessage`, formData)
        .then(function (res) {
          //   console.log(res, "SUCCESS!!");
          //   let response = res.data;
          //   app.updateConversation(response, to);
          for (var i in app.messageList) {
            if (app.messageList[i]["isMessageSending"]) {
              app.messageList[i]["isMessageSending"] = false;
            }
          }
        })
        .catch(function (e) {
          console.log("FAILURE!!", e);
        });
    },

    sendImage(to) {
      const app = this;
      app.imgPreview = app.attachments;
      //   if (app.imMode == "tim") {
      //     app.sentTIMImageMsg();

      //     return false;
      //   }

      let formData = new FormData();
      formData.append("image", app.selectedFile);
      formData.append("message", app.message);
      formData.append("use_socket", 1);
      formData.append("use_tim", 1);
      if (app.imMode == "tim") {
        
        formData.append("chat_type", app.chatType);
      }

      if (to == "client") {
        formData.append("clientId", app.targetId);
      }
      if (to == "employee") {
        formData.append("clientId", app.targetId);
      }
      this.$http
        .post(`/api/v2/${app.type}/sendMessage`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (uploadEvent) {
            app.fileUploadPercent = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
            console.log(app.fileUploadPercent);
          },
        })
        .then(function (res) {
          console.log(res, "SUCCESS!!");
          let response = res.data;
          app.updateConversation(response, to);
        })
        .catch(function (e) {
          console.log("FAILURE!!", e);
        });
    },
    back() {
      localStorage.setItem("tabStatus", "0");
    },
    goBack() {
      let ref = localStorage.getItem("ls-ref");
      if (!ref) {
        let paths = location.pathname.replace("/", "").split("/");
        ref = `/${paths[0]}/${paths[1]}/match/list`;
      }
      location.href = ref;
      //   window.history.go(-4);
      //   location.reload();
    },
    gotoProfile(pLink) {
      window.open(pLink, "_blank");
    },
    callToCs(phone) {
      window.open(phone, "_self");
    },
    openLink(clientID) {
      let url = `${Url.DATETIX}${clientID}`;
      window.open(url, "_blank");
    },
    isvalidMessage() {
      const app = this;
      let re = /\S/;
      if (re.test(app.message) || app.attachments.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    typing() {
      const app = this;
      let text = app.message;
      if (text.length > 0) {
        app.message = text;
        let payload = {
          typing: true,
          lead_id: null,
        };
        if (app.user.isEmployee) {
          payload.clientId = app.targetId;
        }
        if (!app.user.isEmployee) {
          payload.employeeId = app.userInfo.employeeId;
        }
        // if (app.imMode == "websocket") {
        //   this.socket.emit("typing", payload);
        // }
      }
    },
    removeDuplicates(list) {
      const app = this;
      let id = app.user.isEmployee
        ? app.userInfo.data.employee_id
        : app.mm_user_id;
      let cid = app.user.isEmployee ? app.targetId : app.user.id;
      let filteredList = list.filter((item) => {
        if (
          item.from_employee_id == id ||
          item.from_client_id == cid ||
          item.to_client_id == cid
        ) {
          return item;
        }
      });
      return filteredList;
    },
    contentScrolled(e) {
      let position = e.srcElement.scrollTop ? e.srcElement.scrollTop : 0;
      const app = this;
      let msg = app.messageList[app.messageList.length - 1];

      if (
        position == 0 &&
        !app.modalConfig.visible &&
        app.user.isEmployee &&
        app.messageList.length > 3 &&
        app.loadConversation
      ) {
        app.$f7.dialog.preloader();
        this.$http
          .get(
            `/api/v2/${app.type}/conversation?clientId=${app.targetId}&client_msg_id=${msg.client_msg_id}`
          )
          .then((response) => {
            if (response.data.messages.length > 0) {
              if (response.data.messages.length < 200) {
                app.loadConversation = false;
              }
              let mergedList = [...app.messageList, ...response.data.messages];
              app.messageList = _.uniqBy(mergedList, function (e) {
                return e.client_msg_id;
              });
            } else {
              app.loadConversation = false;
            }
            app.$f7.dialog.close();
            // app.scrollDown();

            setTimeout(function () {
              app.scrollDown();
            }, 1800);
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
      if (
        position == 0 &&
        !app.user.isEmployee &&
        app.messageList.length > 3 &&
        app.loadConversation
      ) {
        app.initialLoad = false;
        app.$f7.dialog.preloader();
        this.$http
          .get(
            `/api/v2/${app.type}/conversation?client_msg_id=${msg.client_msg_id}`
          )
          .then((response) => {
            if (response.data.messages.length > 0) {
              let mergedList = [...app.messageList, ...response.data.messages];
              app.messageList = _.uniqBy(mergedList, function (e) {
                return e.client_msg_id;
              });
            }
            app.$f7.dialog.close();
            // app.scrollDown();
            setTimeout(function () {
              app.scrollDown();
            }, 1800);
          })
          .catch(function (error) {
            console.log(error.response);
          });
      }
    },
    updateConversation(response, to) {
      const app = this;
      let data = {
        message: response.msg ? response.msg : " ",
        photoUrl: `${response.photo_url.toString()}`,
        messageId: response.client_msg_id,
        cityId: app.activeCityID,
        autoInsert: false,
      };
      let msgData = {
        isMessageSending: true,
        msg: response.msg ? response.msg : "",
        photo_url: `${Url.FILESTORAGE}${response.photo_path}`,
        sent_time: new Date().toString(),
      };
      if (to == "employee") {
        data["employeeId"] = app.targetId;
        msgData["from_client_id"] = app.targetId;
        msgData["from_employee_id"] = null;
      }
      if (to == "client") {
        data["clientId"] = app.targetId;
        msgData["to_client_id"] = app.targetId;
        msgData["from_client_id"] = null;
        msgData["from_employee"] = {
          first_name: app.userInfo.data.first_name,
          last_name: app.userInfo.data.last_name,
        };
      }
      // if (app.imMode == "websocket") {
      //   this.socket.emit("message", data);
      // }

      app.messageList.unshift(msgData);

      localStorage.setItem("msg", "received");
      app.attachments = [];
      app.imgPreview = [];
      app.message = "";
      app.fileUploadPercent = 0;
    },
    scrollDown() {
      const app = this;
      // console.log("======scrollDown");

      // let msgEl = document.querySelectorAll("div.message");
      // let tHeight = 0;
      // msgEl.forEach(el => {
      //   tHeight += el.clientHeight;
      // });
      // console.log(
      //   "===messages height=",
      //   $(".messages").height(),
      //   tHeight + 200
      // );
      // console.log(
      //   "tHeight=",
      //   tHeight,
      //   tHeight - Math.floor((tHeight * 90) / 100)
      // );
      app.$refs.messages.f7Messages.scroll(
        500,
        $(".messages").height() + 10000
      );
      // app.messages.scroll(500, tHeight - Math.floor((tHeight * 90) / 100));
    },
    modifiedMsg(msg, extras) {
      const app = this;
      let cityURL = app.city_url;
      if (!this.regEx.test(msg)) {
        msg = this.htmlDecode(msg);
      }
      msg = msg.replace(regEx.MATCHES_WITH_SUFFIX, function (matched) {
        if (matched.includes("[Matches")) {
          return `<a href='${Url.MATCHES.replace(
            "[city_url]",
            cityURL
          )}' onclick="window.open('${Url.MATCHES.replace(
            "[city_url]",
            cityURL
          )}','_blank')"> ${regEx.MATCHES.test(matched)
              ? "Matches"
              : matched.match(regEx.MATCHES_WITH_SUFFIX)[
              matched.match(regEx.MATCHES_WITH_SUFFIX).length - 1
              ]
            } </a>`;
        }
      });
      msg = msg.replace(regEx.DATES_WITH_SUFFIX, function (matched) {
        if (matched.includes("[Dates")) {
          return `<a href='${Url.DATES}' onclick="window.open('${Url.DATES
            }','_blank')"> ${regEx.DATES.test(matched)
              ? "Dates"
              : matched.match(regEx.DATES_WITH_SUFFIX)[
              matched.match(regEx.DATES_WITH_SUFFIX).length - 1
              ]
            } </a>`;
        }
      });
      msg = msg.replace(regEx.ME_WITH_SUFFIX, function (matched) {
        if (matched.includes("[Me")) {
          return `<a href='${Url.ME.replace(
            "[city_url]",
            cityURL
          )}' onclick="window.open('${Url.ME.replace(
            "[city_url]",
            cityURL
          )}','_blank')"> ${regEx.ME.test(matched)
              ? "Me"
              : matched.match(regEx.ME_WITH_SUFFIX)[
              matched.match(regEx.ME_WITH_SUFFIX).length - 1
              ]
            } </a>`;
        }
      });
      msg = msg.replace(regEx.REPLY, function (matched) {
        if (matched.includes("[Reply]")) {
          return `<span class="replyMSg"> ${msg.split("[Reply]")[1]} </span>`;
        }
      });

      if (msg.indexOf("[icon_lovestruck]") > -1) {
        msg = msg.replace(
          "[icon_lovestruck]",
          `<img height="28" src="https://cdn-cf2.lovestruck.com/upload-s/gen/img/2021/icon_lovestruck_red.png"/>`
        );
      }
      // msg = msg.replace(/[0-9]{7,}/g, "*******");
      msg = msg.replace("[gold_upgrade_action]", "Upgrade Now");
      msg = msg.replace("[diamond_upgrade_action]", "Upgrade Now");
      try {
        if (typeof extras == "string") {
          extras = JSON.parse(extras);
        }

        if (msg.indexOf("<a>") > -1) {
          let id = _.get(extras, "id", "");
          let t = _.get(extras, "t", "");
          let alink = '<a href="javascript:;">';
          if ((t == "profile" || t == "match-list") && id) {
            let url = `https://v1.datetix.com/employee/clients/add/${id}`;
            alink = `<a href="${url}" onclick="window.open('${url}', '_blank')">`;
          }

          msg = msg.replace("<a>", alink);
        }

        return msg.replace(/\n/g, "</br>").replace(/\r\n/g, "<br/>");
      } catch (err) {
        // console.log("err", msg, err);
        return msg.replace(/\n/g, "</br>").replace(/\r\n/g, "<br/>");
      }

      return msg.replace(/\n/g, "</br>").replace(/\r\n/g, "<br/>");
    },
    htmlDecode(input) {
      //   console.log("input=", input);
      var e = document.createElement("div");
      e.innerHTML = input;
      //   console.log("nodeValue=", $(e).html());
      return $(e).html();
      //   if (e.childNodes[0]) {
      //     return e.childNodes[0].nodeValue;
      //   }
      //   return input;
    },
    onPaste(event) {
      const app = this;
      let text = app.message;
      var items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      for (let index in items) {
        var item = items[index];
        if (item.kind === "file") {
          var blob = item.getAsFile();
          var reader = new FileReader();
          reader.onload = function (event) {
            app.attachments = [];
            app.attachments.unshift(event.target.result);
            app.selectedFile = blob;
          }; // data url!
          reader.readAsDataURL(blob);
        }
      }
      if (text.length > 0) {
        //   text.replace(regEx.DATETIME,`[${}]`)
        app.message = text.replace(regEx.DATETIME, function (matched) {
          return `[${matched}]`;
        });
      }
    },
    openModal: function () {
      const app = this;
      this.modalConfig.visible = true;
      let phone = "";
      if (app.user.isEmployee) {
        this.modalConfig.isCallingToClient = true;
        this.modalConfig.user = this.selectedUser;
        phone = this.selectedUser.phone;
      } else {
        this.modalConfig.isCallingToClient = false;
        this.modalConfig.user = app.activeCity;
        phone = this.activeCity.cs_phone_number;
      }
      this.startCall(phone);
    },
    onFileChanged(event) {
      const self = this;
      self.messageToReply = [];
      self.replyExtras = [];
      self.selectedFile = event.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        self.attachments = [];
        self.attachments.unshift(reader.result);
      };
      reader.readAsDataURL(self.selectedFile);
    },
    deleteAttachment(image) {
      const self = this;
      const index = self.attachments.indexOf(image);
      self.attachments.splice(index, 1)[0]; // eslint-disable-line
    },
    personalMatchMakers() {
      let matchamkers = this.userInfo.data.client.personal_matchmakers;
      let membership_level = this.userInfo.data.client.membership_level_id;
      let matchamkersResult = "";
      if (
        membership_level >= DefaultValue.membership_level_id &&
        matchamkers &&
        matchamkers.length == 1
      ) {
        matchamkersResult = `${matchamkers[0].first_name} ${matchamkers[0].last_name ? matchamkers[0].last_name : ""
          }`;
      } else if (
        membership_level >= DefaultValue.membership_level_id &&
        matchamkers &&
        matchamkers.length > 1
      ) {
        matchamkersResult = matchamkers
          .map((item) => {
            return item.first_name;
          })
          .join(",");
      } else {
        matchamkersResult = "";
      }
      return matchamkersResult;
    },
    reply(e, m) {
      const app = this;
      app.messageToReply = [];
      app.attachments = [];
      app.replyExtras = [];
      app.replyStatus = true;
      let messG = m.msg;
      let repliedMsg = messG.split("[Reply]");
      if (repliedMsg.length > 1) {
        messG = repliedMsg[1];
      }
      if (m.sent_time) {
        let timeSt = new Date(m.sent_time * 1000);
        timeSt = timeSt.toLocaleString();
        messG = messG + "\n\n" + timeSt;
      }

      app.messageToReply.unshift(messG);
      app.replyExtras = m.extras;

      var el = e.target.parentElement;
      var topParentEl = el.parentElement;
      var className = " " + topParentEl.className + " ";
      topParentEl.className = ~className.indexOf(" active ")
        ? className.replace(" active ", " ")
        : topParentEl.className + " active";
      console.log(m);
    },
    deleteReplyAttachment() {
      const app = this;
      app.messageToReply = [];
      app.replyExtras = [];
      app.replyStatus = false;
    },
    showContext(e) {
      var el = e.target.parentElement;
      if (e.target.id == "reply") {
        var className = " " + e.target.className + " ";
        e.target.className = ~className.indexOf(" active ")
          ? className.replace(" active ", " ")
          : e.target.className + " active";
      } else {
        var className = " " + el.className + " ";
        el.className = ~className.indexOf(" active ")
          ? className.replace(" active ", " ")
          : el.className + " active";
      }
    },
    addEmo(e) {
      this.message = this.message + e.target.innerHTML;
    },
    toggleShow() {
      this.show = !this.show;
    },
    onCloseEmoji: function () {
      const self = this;
      self.show = false;
      //console.log('close event called');
    },
  },
  computed: {
    attachmentsVisible() {
      const self = this;
      return self.messageToReply.length > 0 || self.attachments.length > 0;
    },
    placeholder() {
      const self = this;
      return self.attachments.length > 0 || self.messageToReply.length > 0
        ? "Add comment or Send"
        : "Message";
    },
  },

  mounted() {
    const app = this;
    // console.log("app.user=", app.user);

    app.$f7ready(() => {
      //app.messagebar = app.$refs.messagebar.f7Messagebar;
      //app.messages = app.$refs.messages.f7Messages;
    });
    app.origin = window.location.origin;
    app.mm_user_id = app.user.isEmployee
      ? this.$f7route.params.userID
      : app.employee_id;
    app.targetId = app.mm_user_id;
    //    let ids = [parseInt(app.userInfo.data.store_ids)];
    let ids = [parseInt(_.get(app.userInfo, ["data", "store_ids"]))];
    let storeIds = [...ids, ...StoreIds.store_ids];
    if (_.uniq(storeIds).length !== storeIds.length) {
      app.disableSend = true;
    }
    let cityList = JSON.parse(localStorage.getItem("cities"));
    let cityID = app.user.isEmployee
      ? app.userInfo.data.city_id
      : app.userInfo.data.client.city_id;
    app.activeCityID = localStorage.getItem("activeCityID");
    app.city_url = cityList
      .filter((city) => {
        return city.city_id == cityID;
      })
      .map((c) => {
        return c.city_url;
      })
      .toString();
    this.user = JSON.parse(localStorage.getItem("user"));
    this.type = this.user.isEmployee ? "employee" : "client";
    if (cityList.length > 0) {
      cityList.map((city) => {
        if (city.city_id == app.activeCityID) {
          app.activeCity = city;
        }
      });
    }
    if (!this.user.isEmployee) {
      $('div[data-name="home"]').removeClass("view-master-detail");
    }
    app.initialLoad = true;
    app.selectedUser = !_.isEmpty(
      this.$f7route.query && this.$f7route.query.user
    )
      ? JSON.parse(this.$f7route.query.user)
      : {};
    // console.log("selected", app.selectedUser);
    /**
     * "client_status": {
            "client_status_id": 1,
            "description": "服务中",
            "language_id": 2,
            "view_order": 1
        },
     */

    //     if(!app.selectedUser.status){
    //         app.selectedUser.status = _.get(app.selectedUser, 'client_status.description')
    //     }
    // console.log("selected", app.selectedUser);
    app.chatType = _.get(app.selectedUser, "chat_type", "c2c");

    this.getMessage(app.targetId, false);

    if (app.imMode == "tim") {
      //   console.log("app.userInfo=", app.userInfo);
      app.repeatLogin = false;
      app.tencentImUserID = _.get(
        app.userInfo,
        "data.common_tencent_im_userID"
      );
      app.tencentImSig = _.get(app.userInfo, "data.common_tencent_im_sig");
      app.initTIM();
    }

    // if (app.imMode == "websocket") {
    //   this.socket = io("https://im.lovestruck.com", {
    //     //   socket: io("http://localhost:3002", {
    //     // path: "/chat.io",
    //     query: {
    //       token: JSON.parse(localStorage.getItem("user")).token,
    //       // token: getQueryVariable('userType') === 'employee' ? employeeToken : clientToken,
    //       // token: invalidFormatToken
    //     },
    //   });

    //   this.socket.on("message", (data) => {
    //     // console.log("conversation=", data);
    //     if (
    //       app.selectedUser &&
    //       app.user.isEmployee &&
    //       (app.selectedUser.from_client_id == data.clientId ||
    //         app.selectedUser.to_client_id == data.clientId)
    //     ) {
    //       //console.log("dddd-----");
    //       app.messageList.unshift({
    //         msg: unescape(data.message),
    //         from_employee_id: null,
    //         from_client_id: data.clientId,
    //         photo_url: data.photoUrl,
    //         sent_time: new Date().toString(),
    //       });
    //     }
    //     if (!app.user.isEmployee) {
    //       app.messageList.unshift({
    //         msg: unescape(data.message),
    //         from_client_id: null,
    //         from_employee_id: data.employee_id,
    //         photo_url: data.photoUrl,
    //         sent_time: new Date().toString(),
    //       });
    //     }
    //   });
    //   this.socket.on("typing", (data) => {
    //     if (
    //       data.typing &&
    //       data.clientId ==
    //       this.getClientId(
    //         app.selectedUser.from_client_id,
    //         app.selectedUser.to_client_id
    //       )
    //     ) {
    //       this.typingMessage = true;
    //     } else {
    //       this.typingMessage = false;
    //     }
    //   });

    //   // this.socket.on("message_sent", data => {
    //   //   if (data.clientId == app.targetId) {
    //   //     console.log("message from employee test", data);
    //   //     setTimeout(function(){
    //   //       app.getMessage(data.clientId, true);
    //   //     },800)

    //   //   }
    //   // });
    //   this.socket.on("message_finish", (data) => {
    //     console.log("....message_finish");
    //     if (data.clientId == app.targetId) {
    //       console.log("message from employee, insert", data);
    //       // this.getMessage(data.clientId, true);
    //       for (var i in app.messageList) {
    //         if (app.messageList[i]["isMessageSending"]) {
    //           app.messageList[i]["isMessageSending"] = false;
    //         }
    //       }
    //     }
    //   });
    // }

    this.$f7.$(".page-content.messages-content").on("scroll", (e) => {
      this.contentScrolled(e);
    });
    $(window).resize(function () {
      if (!app.user.isEmployee) {
        $('div[data-name="home"]').removeClass("view-master-detail");
      }
    });
    $(function () {
      setTimeout(() => {
        $('div[data-name="conversation"]').last().find("textarea").focus();
        if ($('div[data-name="conversation"]').hasClass("page-previous")) {
          $('div[data-name="conversation"]').first().remove();
        }
      }, 600);
    });
  },
};
</script>